import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _23f8d57b = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _31bcd890 = () => interopDefault(import('../pages/ai_photo_enhancer_app/index.vue' /* webpackChunkName: "pages/ai_photo_enhancer_app/index" */))
const _6f966d9a = () => interopDefault(import('../pages/demo/index.vue' /* webpackChunkName: "pages/demo/index" */))
const _acb1d756 = () => interopDefault(import('../pages/download.vue' /* webpackChunkName: "pages/download" */))
const _e69a9588 = () => interopDefault(import('../pages/downloadApp.vue' /* webpackChunkName: "pages/downloadApp" */))
const _640dd854 = () => interopDefault(import('../pages/explore.vue' /* webpackChunkName: "pages/explore" */))
const _e0ba6dae = () => interopDefault(import('../pages/formula.vue' /* webpackChunkName: "pages/formula" */))
const _c5ebec64 = () => interopDefault(import('../pages/image-page.vue' /* webpackChunkName: "pages/image-page" */))
const _617653a4 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _323aeddc = () => interopDefault(import('../pages/terms-of-service.vue' /* webpackChunkName: "pages/terms-of-service" */))
const _354492f0 = () => interopDefault(import('../pages/vip_discount.vue' /* webpackChunkName: "pages/vip_discount" */))
const _a81c8290 = () => interopDefault(import('../pages/agent/chat-replay/index.vue' /* webpackChunkName: "pages/agent/chat-replay/index" */))
const _02b6b9d8 = () => interopDefault(import('../pages/agent/quick-guide/index.vue' /* webpackChunkName: "pages/agent/quick-guide/index" */))
const _8852c368 = () => interopDefault(import('../pages/campaign/photo-enhancer-mobile-sem.vue' /* webpackChunkName: "pages/campaign/photo-enhancer-mobile-sem" */))
const _7dd4b4fc = () => interopDefault(import('../pages/demo/animate.vue' /* webpackChunkName: "pages/demo/animate" */))
const _2c0424a4 = () => interopDefault(import('../pages/demo/dir.vue' /* webpackChunkName: "pages/demo/dir" */))
const _59fa42b2 = () => interopDefault(import('../pages/demo/goart-general-article-layout.vue' /* webpackChunkName: "pages/demo/goart-general-article-layout" */))
const _e0210230 = () => interopDefault(import('../pages/demo/goart-general-confirm-box.vue' /* webpackChunkName: "pages/demo/goart-general-confirm-box" */))
const _549dec5d = () => interopDefault(import('../pages/demo/info.vue' /* webpackChunkName: "pages/demo/info" */))
const _1b5e5d70 = () => interopDefault(import('../pages/demo/mediaDemo.vue' /* webpackChunkName: "pages/demo/mediaDemo" */))
const _7a637a07 = () => interopDefault(import('../pages/demo/moreDemo.vue' /* webpackChunkName: "pages/demo/moreDemo" */))
const _64fb5cf4 = () => interopDefault(import('../pages/demo/native.vue' /* webpackChunkName: "pages/demo/native" */))
const _080f3444 = () => interopDefault(import('../pages/demo/sdkDemo.vue' /* webpackChunkName: "pages/demo/sdkDemo" */))
const _563efbae = () => interopDefault(import('../pages/demo/svg-pause.vue' /* webpackChunkName: "pages/demo/svg-pause" */))
const _05c031ac = () => interopDefault(import('../pages/demo/svg-play.vue' /* webpackChunkName: "pages/demo/svg-play" */))
const _42a38a53 = () => interopDefault(import('../pages/demo/testMedia.vue' /* webpackChunkName: "pages/demo/testMedia" */))
const _8ad2807a = () => interopDefault(import('../pages/demo/video-test-component.vue' /* webpackChunkName: "pages/demo/video-test-component" */))
const _099128a0 = () => interopDefault(import('../pages/demo/videoPlay.vue' /* webpackChunkName: "pages/demo/videoPlay" */))
const _2205d1f1 = () => interopDefault(import('../pages/desktop/Fotor_Qt_License_Notice.vue' /* webpackChunkName: "pages/desktop/Fotor_Qt_License_Notice" */))
const _37a148cf = () => interopDefault(import('../pages/desktop/FotorDesign_Qt_License_Notice.vue' /* webpackChunkName: "pages/desktop/FotorDesign_Qt_License_Notice" */))
const _e3c12ac4 = () => interopDefault(import('../pages/desktop/GoArt_Qt_License_Notice.vue' /* webpackChunkName: "pages/desktop/GoArt_Qt_License_Notice" */))
const _3cede377 = () => interopDefault(import('../pages/desktop/privacy-policy.vue' /* webpackChunkName: "pages/desktop/privacy-policy" */))
const _349ca710 = () => interopDefault(import('../pages/desktop/term-of-service.vue' /* webpackChunkName: "pages/desktop/term-of-service" */))
const _c8ca469e = () => interopDefault(import('../pages/facewow/privacy-policy.vue' /* webpackChunkName: "pages/facewow/privacy-policy" */))
const _32cbe780 = () => interopDefault(import('../pages/facewow/privacy-policy-desktop.vue' /* webpackChunkName: "pages/facewow/privacy-policy-desktop" */))
const _a8e255d4 = () => interopDefault(import('../pages/facewow/term-of-service.vue' /* webpackChunkName: "pages/facewow/term-of-service" */))
const _6a47aae5 = () => interopDefault(import('../pages/facewow/term-of-service-desktop.vue' /* webpackChunkName: "pages/facewow/term-of-service-desktop" */))
const _7728c5a9 = () => interopDefault(import('../pages/goart/download.vue' /* webpackChunkName: "pages/goart/download" */))
const _640830fc = () => interopDefault(import('../pages/goart/download_v2.vue' /* webpackChunkName: "pages/goart/download_v2" */))
const _0906ff6c = () => interopDefault(import('../pages/mobile/aboutsubscription.vue' /* webpackChunkName: "pages/mobile/aboutsubscription" */))
const _2e84ee58 = () => interopDefault(import('../pages/mobile/agent-rule.vue' /* webpackChunkName: "pages/mobile/agent-rule" */))
const _6678ef24 = () => interopDefault(import('../pages/mobile/ai-photo-enhancer.vue' /* webpackChunkName: "pages/mobile/ai-photo-enhancer" */))
const _2b7e99eb = () => interopDefault(import('../pages/mobile/aigc_faq.vue' /* webpackChunkName: "pages/mobile/aigc_faq" */))
const _4031e3cb = () => interopDefault(import('../pages/mobile/cancel-fotor-account.vue' /* webpackChunkName: "pages/mobile/cancel-fotor-account" */))
const _30fc52b0 = () => interopDefault(import('../pages/mobile/clipfly_rule.vue' /* webpackChunkName: "pages/mobile/clipfly_rule" */))
const _72306ff2 = () => interopDefault(import('../pages/mobile/jump_schema.vue' /* webpackChunkName: "pages/mobile/jump_schema" */))
const _4e0e5e60 = () => interopDefault(import('../pages/mobile/redeem_code.vue' /* webpackChunkName: "pages/mobile/redeem_code" */))
const _2408fac2 = () => interopDefault(import('../pages/mobile/resource_detail.vue' /* webpackChunkName: "pages/mobile/resource_detail" */))
const _b2da758a = () => interopDefault(import('../pages/mobile/rule-description.vue' /* webpackChunkName: "pages/mobile/rule-description" */))
const _ffc0c5b6 = () => interopDefault(import('../pages/mobile/tool_guide.vue' /* webpackChunkName: "pages/mobile/tool_guide" */))
const _750f1388 = () => interopDefault(import('../pages/mobile/verif-user.vue' /* webpackChunkName: "pages/mobile/verif-user" */))
const _336d7882 = () => interopDefault(import('../pages/mobile/welcome.vue' /* webpackChunkName: "pages/mobile/welcome" */))
const _2c7ea066 = () => interopDefault(import('../pages/mobile/welcome-user.vue' /* webpackChunkName: "pages/mobile/welcome-user" */))
const _6f97481c = () => interopDefault(import('../pages/mobile/welcome-user备份2023-6-14.vue' /* webpackChunkName: "pages/mobile/welcome-user备份2023-6-14" */))
const _22df8680 = () => interopDefault(import('../pages/mobile/welcome备份2023-6-14.vue' /* webpackChunkName: "pages/mobile/welcome备份2023-6-14" */))
const _080f6c85 = () => interopDefault(import('../pages/portraitme/privacy-policy-desktop.vue' /* webpackChunkName: "pages/portraitme/privacy-policy-desktop" */))
const _3d74c680 = () => interopDefault(import('../pages/portraitme/term-of-service-desktop.vue' /* webpackChunkName: "pages/portraitme/term-of-service-desktop" */))
const _2f72a4f0 = () => interopDefault(import('../pages/mobile/activity/christmas-2021.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2021" */))
const _2f5675ee = () => interopDefault(import('../pages/mobile/activity/christmas-2022.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2022" */))
const _09b6538d = () => interopDefault(import('../pages/mobile/activity/christmas-2023/index.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2023/index" */))
const _c2c9f364 = () => interopDefault(import('../pages/mobile/activity/christmas-2024/index.vue' /* webpackChunkName: "pages/mobile/activity/christmas-2024/index" */))
const _495576f0 = () => interopDefault(import('../pages/mobile/activity/free_code.vue' /* webpackChunkName: "pages/mobile/activity/free_code" */))
const _2c394af8 = () => interopDefault(import('../pages/mobile/activity/function.vue' /* webpackChunkName: "pages/mobile/activity/function" */))
const _11c34cf7 = () => interopDefault(import('../pages/mobile/activity/function-bg-remove.vue' /* webpackChunkName: "pages/mobile/activity/function-bg-remove" */))
const _394efec4 = () => interopDefault(import('../pages/mobile/activity/halloween-2022.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2022" */))
const _6dc24b62 = () => interopDefault(import('../pages/mobile/activity/halloween-2023/index.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2023/index" */))
const _02a6fe23 = () => interopDefault(import('../pages/mobile/activity/halloween-2024/index.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2024/index" */))
const _0629ad3a = () => interopDefault(import('../pages/mobile/activity/join_fotor_code.vue' /* webpackChunkName: "pages/mobile/activity/join_fotor_code" */))
const _106be546 = () => interopDefault(import('../pages/mobile/activity/join_terabox_code.vue' /* webpackChunkName: "pages/mobile/activity/join_terabox_code" */))
const _9cc16dbc = () => interopDefault(import('../pages/mobile/activity/price-increase-notification.vue' /* webpackChunkName: "pages/mobile/activity/price-increase-notification" */))
const _1c4fac90 = () => interopDefault(import('../pages/mobile/activity/share_free_code.vue' /* webpackChunkName: "pages/mobile/activity/share_free_code" */))
const _56975b12 = () => interopDefault(import('../pages/mobile/activity/share-2025/index.vue' /* webpackChunkName: "pages/mobile/activity/share-2025/index" */))
const _45361516 = () => interopDefault(import('../pages/mobile/activity/valentine-2023.vue' /* webpackChunkName: "pages/mobile/activity/valentine-2023" */))
const _09585f50 = () => interopDefault(import('../pages/mobile/activity/wallpaperdesign.vue' /* webpackChunkName: "pages/mobile/activity/wallpaperdesign" */))
const _4e1211a6 = () => interopDefault(import('../pages/mobile/clipfly/downloadApp.vue' /* webpackChunkName: "pages/mobile/clipfly/downloadApp" */))
const _454be375 = () => interopDefault(import('../pages/mobile/clipfly/helpCenter/index.vue' /* webpackChunkName: "pages/mobile/clipfly/helpCenter/index" */))
const _504cb1f6 = () => interopDefault(import('../pages/mobile/clipfly/invite.vue' /* webpackChunkName: "pages/mobile/clipfly/invite" */))
const _6e0125d4 = () => interopDefault(import('../pages/mobile/clipfly/song/index.vue' /* webpackChunkName: "pages/mobile/clipfly/song/index" */))
const _ed3012c6 = () => interopDefault(import('../pages/mobile/clipfly/storys/index.vue' /* webpackChunkName: "pages/mobile/clipfly/storys/index" */))
const _26641cd9 = () => interopDefault(import('../pages/mobile/clipfly/survey/index.vue' /* webpackChunkName: "pages/mobile/clipfly/survey/index" */))
const _82931a68 = () => interopDefault(import('../pages/mobile/facewow/cancel-facewow-account.vue' /* webpackChunkName: "pages/mobile/facewow/cancel-facewow-account" */))
const _3810ece6 = () => interopDefault(import('../pages/mobile/goArt/ai-picture-faq.vue' /* webpackChunkName: "pages/mobile/goArt/ai-picture-faq" */))
const _36312159 = () => interopDefault(import('../pages/mobile/goArt/ai-picture-from-picutre.vue' /* webpackChunkName: "pages/mobile/goArt/ai-picture-from-picutre" */))
const _8a2c9672 = () => interopDefault(import('../pages/mobile/goArt/blockInfo.vue' /* webpackChunkName: "pages/mobile/goArt/blockInfo" */))
const _f04c79c4 = () => interopDefault(import('../pages/mobile/goArt/cancel-account.vue' /* webpackChunkName: "pages/mobile/goArt/cancel-account" */))
const _478a9d43 = () => interopDefault(import('../pages/mobile/goArt/exchange-code.vue' /* webpackChunkName: "pages/mobile/goArt/exchange-code" */))
const _c682a666 = () => interopDefault(import('../pages/mobile/goArt/invite.vue' /* webpackChunkName: "pages/mobile/goArt/invite" */))
const _71af6ca0 = () => interopDefault(import('../pages/mobile/goArt/invite-2024.vue' /* webpackChunkName: "pages/mobile/goArt/invite-2024" */))
const _4d8da996 = () => interopDefault(import('../pages/mobile/goArt/invite-blind-box/index.vue' /* webpackChunkName: "pages/mobile/goArt/invite-blind-box/index" */))
const _25cb55f8 = () => interopDefault(import('../pages/mobile/goArt/privacy_en.vue' /* webpackChunkName: "pages/mobile/goArt/privacy_en" */))
const _109b8d09 = () => interopDefault(import('../pages/mobile/goArt/privacy_zh.vue' /* webpackChunkName: "pages/mobile/goArt/privacy_zh" */))
const _40a643d2 = () => interopDefault(import('../pages/mobile/goArt/sdk_zh.vue' /* webpackChunkName: "pages/mobile/goArt/sdk_zh" */))
const _d7b9c4d4 = () => interopDefault(import('../pages/mobile/goArt/services_en.vue' /* webpackChunkName: "pages/mobile/goArt/services_en" */))
const _028c2716 = () => interopDefault(import('../pages/mobile/goArt/services_en_v2.vue' /* webpackChunkName: "pages/mobile/goArt/services_en_v2" */))
const _026ff814 = () => interopDefault(import('../pages/mobile/goArt/services_en_v3.vue' /* webpackChunkName: "pages/mobile/goArt/services_en_v3" */))
const _90b754ca = () => interopDefault(import('../pages/mobile/goArt/services_zh.vue' /* webpackChunkName: "pages/mobile/goArt/services_zh" */))
const _283a92d2 = () => interopDefault(import('../pages/mobile/goArt/user/index.vue' /* webpackChunkName: "pages/mobile/goArt/user/index" */))
const _f8a2e2d0 = () => interopDefault(import('../pages/mobile/goArt/work/index.vue' /* webpackChunkName: "pages/mobile/goArt/work/index" */))
const _438a87d9 = () => interopDefault(import('../pages/mobile/helper/android_vip_upgrade.vue' /* webpackChunkName: "pages/mobile/helper/android_vip_upgrade" */))
const _7ad26685 = () => interopDefault(import('../pages/mobile/helper/beauty-camera.vue' /* webpackChunkName: "pages/mobile/helper/beauty-camera" */))
const _82b81e0e = () => interopDefault(import('../pages/mobile/helper/center/index.vue' /* webpackChunkName: "pages/mobile/helper/center/index" */))
const _5e590d2c = () => interopDefault(import('../pages/mobile/helper/center2.vue' /* webpackChunkName: "pages/mobile/helper/center2" */))
const _f0879e6a = () => interopDefault(import('../pages/mobile/helper/upgrade-android-to-ios.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-android-to-ios" */))
const _428fcd0d = () => interopDefault(import('../pages/mobile/helper/upgrade-android-to-mac.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-android-to-mac" */))
const _a52a1262 = () => interopDefault(import('../pages/mobile/helper/upgrade-ios-to-android.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-ios-to-android" */))
const _4df84ca2 = () => interopDefault(import('../pages/mobile/helper/upgrade-ios-to-mac.vue' /* webpackChunkName: "pages/mobile/helper/upgrade-ios-to-mac" */))
const _24e27eae = () => interopDefault(import('../pages/mobile/helper/vip_upgrade.vue' /* webpackChunkName: "pages/mobile/helper/vip_upgrade" */))
const _2bad4678 = () => interopDefault(import('../pages/mobile/helper/what-new.vue' /* webpackChunkName: "pages/mobile/helper/what-new" */))
const _e7204b3c = () => interopDefault(import('../pages/mobile/activity/aigc/ai-cartoonizer.vue' /* webpackChunkName: "pages/mobile/activity/aigc/ai-cartoonizer" */))
const _55a6a3d2 = () => interopDefault(import('../pages/mobile/activity/aigc/ai-ideal-mate.vue' /* webpackChunkName: "pages/mobile/activity/aigc/ai-ideal-mate" */))
const _2fcd70ae = () => interopDefault(import('../pages/mobile/activity/aigc/ai-sing.vue' /* webpackChunkName: "pages/mobile/activity/aigc/ai-sing" */))
const _ed057fa0 = () => interopDefault(import('../pages/mobile/clipfly/activity/rule.vue' /* webpackChunkName: "pages/mobile/clipfly/activity/rule" */))
const _1567eff2 = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/index.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/index" */))
const _054f9c08 = () => interopDefault(import('../pages/mobile/goArt/activity/new-self/index.vue' /* webpackChunkName: "pages/mobile/goArt/activity/new-self/index" */))
const _338e4886 = () => interopDefault(import('../pages/mobile/goArt/activity/valentines_day.vue' /* webpackChunkName: "pages/mobile/goArt/activity/valentines_day" */))
const _693cab08 = () => interopDefault(import('../pages/mobile/goArt/digital-collection/user-list.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/user-list" */))
const _08735532 = () => interopDefault(import('../pages/mobile/goArt/invite-blind-box/Invited-friends.vue' /* webpackChunkName: "pages/mobile/goArt/invite-blind-box/Invited-friends" */))
const _d6c0ea4e = () => interopDefault(import('../pages/mobile/goArt/invite-blind-box/lucky-draw-record.vue' /* webpackChunkName: "pages/mobile/goArt/invite-blind-box/lucky-draw-record" */))
const _48a85ba6 = () => interopDefault(import('../pages/mobile/goArt/nft/casting-instructions.vue' /* webpackChunkName: "pages/mobile/goArt/nft/casting-instructions" */))
const _47874eed = () => interopDefault(import('../pages/mobile/goArt/nft/helpCenter.vue' /* webpackChunkName: "pages/mobile/goArt/nft/helpCenter" */))
const _7e68e49b = () => interopDefault(import('../pages/mobile/goArt/nft/how-to-check-nft-on-opensea.vue' /* webpackChunkName: "pages/mobile/goArt/nft/how-to-check-nft-on-opensea" */))
const _5e4241a3 = () => interopDefault(import('../pages/mobile/goArt/nft/how-to-view-nft-works-in-opensea.vue' /* webpackChunkName: "pages/mobile/goArt/nft/how-to-view-nft-works-in-opensea" */))
const _d9600ae6 = () => interopDefault(import('../pages/mobile/goArt/nft/news/index.vue' /* webpackChunkName: "pages/mobile/goArt/nft/news/index" */))
const _4f9f4893 = () => interopDefault(import('../pages/mobile/goArt/nft/what-is-encrypted-wallet.vue' /* webpackChunkName: "pages/mobile/goArt/nft/what-is-encrypted-wallet" */))
const _1a118584 = () => interopDefault(import('../pages/mobile/activity/halloween-2024/views/centerPage.vue' /* webpackChunkName: "pages/mobile/activity/halloween-2024/views/centerPage" */))
const _4a463708 = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/contribute.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/contribute" */))
const _1a0cf9ee = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/info.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/info" */))
const _93cb4728 = () => interopDefault(import('../pages/mobile/goArt/activity/ai-works-campaign/record.vue' /* webpackChunkName: "pages/mobile/goArt/activity/ai-works-campaign/record" */))
const _efba2a30 = () => interopDefault(import('../pages/mobile/goArt/activity/new-self/info.vue' /* webpackChunkName: "pages/mobile/goArt/activity/new-self/info" */))
const _b314bd6a = () => interopDefault(import('../pages/mobile/goArt/digital-collection/product/all-series.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/product/all-series" */))
const _25ed109e = () => interopDefault(import('../pages/mobile/goArt/nft/article/1.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/1" */))
const _25d0e19c = () => interopDefault(import('../pages/mobile/goArt/nft/article/2.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/2" */))
const _25b4b29a = () => interopDefault(import('../pages/mobile/goArt/nft/article/3.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/3" */))
const _25988398 = () => interopDefault(import('../pages/mobile/goArt/nft/article/4.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/4" */))
const _257c5496 = () => interopDefault(import('../pages/mobile/goArt/nft/article/5.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/5" */))
const _25602594 = () => interopDefault(import('../pages/mobile/goArt/nft/article/6.vue' /* webpackChunkName: "pages/mobile/goArt/nft/article/6" */))
const _d814fd1a = () => interopDefault(import('../pages/mobile/goArt/nft/protocol/guidelines.vue' /* webpackChunkName: "pages/mobile/goArt/nft/protocol/guidelines" */))
const _430d1f78 = () => interopDefault(import('../pages/mobile/goArt/nft/protocol/guidelines_v2.vue' /* webpackChunkName: "pages/mobile/goArt/nft/protocol/guidelines_v2" */))
const _13f5afbf = () => interopDefault(import('../pages/mobile/goArt/nft/protocol/permission.vue' /* webpackChunkName: "pages/mobile/goArt/nft/protocol/permission" */))
const _2ccf1955 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _d27f4ef4 = () => interopDefault(import('../pages/mobile/goArt/digital-collection/mine/_id.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/mine/_id" */))
const _6c89f942 = () => interopDefault(import('../pages/mobile/goArt/digital-collection/product/_id.vue' /* webpackChunkName: "pages/mobile/goArt/digital-collection/product/_id" */))
const _3fc53c35 = () => interopDefault(import('../pages/mobile/goArt/nft/news/_id.vue' /* webpackChunkName: "pages/mobile/goArt/nft/news/_id" */))
const _d254bf32 = () => interopDefault(import('../pages/mobile/open-app/_position.vue' /* webpackChunkName: "pages/mobile/open-app/_position" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _23f8d57b,
    name: "404"
  }, {
    path: "/ai_photo_enhancer_app",
    component: _31bcd890,
    name: "ai_photo_enhancer_app"
  }, {
    path: "/demo",
    component: _6f966d9a,
    name: "demo"
  }, {
    path: "/download",
    component: _acb1d756,
    name: "download"
  }, {
    path: "/downloadApp",
    component: _e69a9588,
    name: "downloadApp"
  }, {
    path: "/explore",
    component: _640dd854,
    name: "explore"
  }, {
    path: "/formula",
    component: _e0ba6dae,
    name: "formula"
  }, {
    path: "/image-page",
    component: _c5ebec64,
    name: "image-page"
  }, {
    path: "/privacy-policy",
    component: _617653a4,
    name: "privacy-policy"
  }, {
    path: "/terms-of-service",
    component: _323aeddc,
    name: "terms-of-service"
  }, {
    path: "/vip_discount",
    component: _354492f0,
    name: "vip_discount"
  }, {
    path: "/agent/chat-replay",
    component: _a81c8290,
    name: "agent-chat-replay"
  }, {
    path: "/agent/quick-guide",
    component: _02b6b9d8,
    name: "agent-quick-guide"
  }, {
    path: "/campaign/photo-enhancer-mobile-sem",
    component: _8852c368,
    name: "campaign-photo-enhancer-mobile-sem"
  }, {
    path: "/demo/animate",
    component: _7dd4b4fc,
    name: "demo-animate"
  }, {
    path: "/demo/dir",
    component: _2c0424a4,
    name: "demo-dir"
  }, {
    path: "/demo/goart-general-article-layout",
    component: _59fa42b2,
    name: "demo-goart-general-article-layout"
  }, {
    path: "/demo/goart-general-confirm-box",
    component: _e0210230,
    name: "demo-goart-general-confirm-box"
  }, {
    path: "/demo/info",
    component: _549dec5d,
    name: "demo-info"
  }, {
    path: "/demo/mediaDemo",
    component: _1b5e5d70,
    name: "demo-mediaDemo"
  }, {
    path: "/demo/moreDemo",
    component: _7a637a07,
    name: "demo-moreDemo"
  }, {
    path: "/demo/native",
    component: _64fb5cf4,
    name: "demo-native"
  }, {
    path: "/demo/sdkDemo",
    component: _080f3444,
    name: "demo-sdkDemo"
  }, {
    path: "/demo/svg-pause",
    component: _563efbae,
    name: "demo-svg-pause"
  }, {
    path: "/demo/svg-play",
    component: _05c031ac,
    name: "demo-svg-play"
  }, {
    path: "/demo/testMedia",
    component: _42a38a53,
    name: "demo-testMedia"
  }, {
    path: "/demo/video-test-component",
    component: _8ad2807a,
    name: "demo-video-test-component"
  }, {
    path: "/demo/videoPlay",
    component: _099128a0,
    name: "demo-videoPlay"
  }, {
    path: "/desktop/Fotor_Qt_License_Notice",
    component: _2205d1f1,
    name: "desktop-Fotor_Qt_License_Notice"
  }, {
    path: "/desktop/FotorDesign_Qt_License_Notice",
    component: _37a148cf,
    name: "desktop-FotorDesign_Qt_License_Notice"
  }, {
    path: "/desktop/GoArt_Qt_License_Notice",
    component: _e3c12ac4,
    name: "desktop-GoArt_Qt_License_Notice"
  }, {
    path: "/desktop/privacy-policy",
    component: _3cede377,
    name: "desktop-privacy-policy"
  }, {
    path: "/desktop/term-of-service",
    component: _349ca710,
    name: "desktop-term-of-service"
  }, {
    path: "/facewow/privacy-policy",
    component: _c8ca469e,
    name: "facewow-privacy-policy"
  }, {
    path: "/facewow/privacy-policy-desktop",
    component: _32cbe780,
    name: "facewow-privacy-policy-desktop"
  }, {
    path: "/facewow/term-of-service",
    component: _a8e255d4,
    name: "facewow-term-of-service"
  }, {
    path: "/facewow/term-of-service-desktop",
    component: _6a47aae5,
    name: "facewow-term-of-service-desktop"
  }, {
    path: "/goart/download",
    component: _7728c5a9,
    name: "goart-download"
  }, {
    path: "/goart/download_v2",
    component: _640830fc,
    name: "goart-download_v2"
  }, {
    path: "/mobile/aboutsubscription",
    component: _0906ff6c,
    name: "mobile-aboutsubscription"
  }, {
    path: "/mobile/agent-rule",
    component: _2e84ee58,
    name: "mobile-agent-rule"
  }, {
    path: "/mobile/ai-photo-enhancer",
    component: _6678ef24,
    name: "mobile-ai-photo-enhancer"
  }, {
    path: "/mobile/aigc_faq",
    component: _2b7e99eb,
    name: "mobile-aigc_faq"
  }, {
    path: "/mobile/cancel-fotor-account",
    component: _4031e3cb,
    name: "mobile-cancel-fotor-account"
  }, {
    path: "/mobile/clipfly_rule",
    component: _30fc52b0,
    name: "mobile-clipfly_rule"
  }, {
    path: "/mobile/jump_schema",
    component: _72306ff2,
    name: "mobile-jump_schema"
  }, {
    path: "/mobile/redeem_code",
    component: _4e0e5e60,
    name: "mobile-redeem_code"
  }, {
    path: "/mobile/resource_detail",
    component: _2408fac2,
    name: "mobile-resource_detail"
  }, {
    path: "/mobile/rule-description",
    component: _b2da758a,
    name: "mobile-rule-description"
  }, {
    path: "/mobile/tool_guide",
    component: _ffc0c5b6,
    name: "mobile-tool_guide"
  }, {
    path: "/mobile/verif-user",
    component: _750f1388,
    name: "mobile-verif-user"
  }, {
    path: "/mobile/welcome",
    component: _336d7882,
    name: "mobile-welcome"
  }, {
    path: "/mobile/welcome-user",
    component: _2c7ea066,
    name: "mobile-welcome-user"
  }, {
    path: "/mobile/welcome-user%E5%A4%87%E4%BB%BD2023-6-14",
    component: _6f97481c,
    name: "mobile-welcome-user备份2023-6-14"
  }, {
    path: "/mobile/welcome%E5%A4%87%E4%BB%BD2023-6-14",
    component: _22df8680,
    name: "mobile-welcome备份2023-6-14"
  }, {
    path: "/portraitme/privacy-policy-desktop",
    component: _080f6c85,
    name: "portraitme-privacy-policy-desktop"
  }, {
    path: "/portraitme/term-of-service-desktop",
    component: _3d74c680,
    name: "portraitme-term-of-service-desktop"
  }, {
    path: "/mobile/activity/christmas-2021",
    component: _2f72a4f0,
    name: "mobile-activity-christmas-2021"
  }, {
    path: "/mobile/activity/christmas-2022",
    component: _2f5675ee,
    name: "mobile-activity-christmas-2022"
  }, {
    path: "/mobile/activity/christmas-2023",
    component: _09b6538d,
    name: "mobile-activity-christmas-2023"
  }, {
    path: "/mobile/activity/christmas-2024",
    component: _c2c9f364,
    name: "mobile-activity-christmas-2024"
  }, {
    path: "/mobile/activity/free_code",
    component: _495576f0,
    name: "mobile-activity-free_code"
  }, {
    path: "/mobile/activity/function",
    component: _2c394af8,
    name: "mobile-activity-function"
  }, {
    path: "/mobile/activity/function-bg-remove",
    component: _11c34cf7,
    name: "mobile-activity-function-bg-remove"
  }, {
    path: "/mobile/activity/halloween-2022",
    component: _394efec4,
    name: "mobile-activity-halloween-2022"
  }, {
    path: "/mobile/activity/halloween-2023",
    component: _6dc24b62,
    name: "mobile-activity-halloween-2023"
  }, {
    path: "/mobile/activity/halloween-2024",
    component: _02a6fe23,
    name: "mobile-activity-halloween-2024"
  }, {
    path: "/mobile/activity/join_fotor_code",
    component: _0629ad3a,
    name: "mobile-activity-join_fotor_code"
  }, {
    path: "/mobile/activity/join_terabox_code",
    component: _106be546,
    name: "mobile-activity-join_terabox_code"
  }, {
    path: "/mobile/activity/price-increase-notification",
    component: _9cc16dbc,
    name: "mobile-activity-price-increase-notification"
  }, {
    path: "/mobile/activity/share_free_code",
    component: _1c4fac90,
    name: "mobile-activity-share_free_code"
  }, {
    path: "/mobile/activity/share-2025",
    component: _56975b12,
    name: "mobile-activity-share-2025"
  }, {
    path: "/mobile/activity/valentine-2023",
    component: _45361516,
    name: "mobile-activity-valentine-2023"
  }, {
    path: "/mobile/activity/wallpaperdesign",
    component: _09585f50,
    name: "mobile-activity-wallpaperdesign"
  }, {
    path: "/mobile/clipfly/downloadApp",
    component: _4e1211a6,
    name: "mobile-clipfly-downloadApp"
  }, {
    path: "/mobile/clipfly/helpCenter",
    component: _454be375,
    name: "mobile-clipfly-helpCenter"
  }, {
    path: "/mobile/clipfly/invite",
    component: _504cb1f6,
    name: "mobile-clipfly-invite"
  }, {
    path: "/mobile/clipfly/song",
    component: _6e0125d4,
    name: "mobile-clipfly-song"
  }, {
    path: "/mobile/clipfly/storys",
    component: _ed3012c6,
    name: "mobile-clipfly-storys"
  }, {
    path: "/mobile/clipfly/survey",
    component: _26641cd9,
    name: "mobile-clipfly-survey"
  }, {
    path: "/mobile/facewow/cancel-facewow-account",
    component: _82931a68,
    name: "mobile-facewow-cancel-facewow-account"
  }, {
    path: "/mobile/goArt/ai-picture-faq",
    component: _3810ece6,
    name: "mobile-goArt-ai-picture-faq"
  }, {
    path: "/mobile/goArt/ai-picture-from-picutre",
    component: _36312159,
    name: "mobile-goArt-ai-picture-from-picutre"
  }, {
    path: "/mobile/goArt/blockInfo",
    component: _8a2c9672,
    name: "mobile-goArt-blockInfo"
  }, {
    path: "/mobile/goArt/cancel-account",
    component: _f04c79c4,
    name: "mobile-goArt-cancel-account"
  }, {
    path: "/mobile/goArt/exchange-code",
    component: _478a9d43,
    name: "mobile-goArt-exchange-code"
  }, {
    path: "/mobile/goArt/invite",
    component: _c682a666,
    name: "mobile-goArt-invite"
  }, {
    path: "/mobile/goArt/invite-2024",
    component: _71af6ca0,
    name: "mobile-goArt-invite-2024"
  }, {
    path: "/mobile/goArt/invite-blind-box",
    component: _4d8da996,
    name: "mobile-goArt-invite-blind-box"
  }, {
    path: "/mobile/goArt/privacy_en",
    component: _25cb55f8,
    name: "mobile-goArt-privacy_en"
  }, {
    path: "/mobile/goArt/privacy_zh",
    component: _109b8d09,
    name: "mobile-goArt-privacy_zh"
  }, {
    path: "/mobile/goArt/sdk_zh",
    component: _40a643d2,
    name: "mobile-goArt-sdk_zh"
  }, {
    path: "/mobile/goArt/services_en",
    component: _d7b9c4d4,
    name: "mobile-goArt-services_en"
  }, {
    path: "/mobile/goArt/services_en_v2",
    component: _028c2716,
    name: "mobile-goArt-services_en_v2"
  }, {
    path: "/mobile/goArt/services_en_v3",
    component: _026ff814,
    name: "mobile-goArt-services_en_v3"
  }, {
    path: "/mobile/goArt/services_zh",
    component: _90b754ca,
    name: "mobile-goArt-services_zh"
  }, {
    path: "/mobile/goArt/user",
    component: _283a92d2,
    name: "mobile-goArt-user"
  }, {
    path: "/mobile/goArt/work",
    component: _f8a2e2d0,
    name: "mobile-goArt-work"
  }, {
    path: "/mobile/helper/android_vip_upgrade",
    component: _438a87d9,
    name: "mobile-helper-android_vip_upgrade"
  }, {
    path: "/mobile/helper/beauty-camera",
    component: _7ad26685,
    name: "mobile-helper-beauty-camera"
  }, {
    path: "/mobile/helper/center",
    component: _82b81e0e,
    name: "mobile-helper-center"
  }, {
    path: "/mobile/helper/center2",
    component: _5e590d2c,
    name: "mobile-helper-center2"
  }, {
    path: "/mobile/helper/upgrade-android-to-ios",
    component: _f0879e6a,
    name: "mobile-helper-upgrade-android-to-ios"
  }, {
    path: "/mobile/helper/upgrade-android-to-mac",
    component: _428fcd0d,
    name: "mobile-helper-upgrade-android-to-mac"
  }, {
    path: "/mobile/helper/upgrade-ios-to-android",
    component: _a52a1262,
    name: "mobile-helper-upgrade-ios-to-android"
  }, {
    path: "/mobile/helper/upgrade-ios-to-mac",
    component: _4df84ca2,
    name: "mobile-helper-upgrade-ios-to-mac"
  }, {
    path: "/mobile/helper/vip_upgrade",
    component: _24e27eae,
    name: "mobile-helper-vip_upgrade"
  }, {
    path: "/mobile/helper/what-new",
    component: _2bad4678,
    name: "mobile-helper-what-new"
  }, {
    path: "/mobile/activity/aigc/ai-cartoonizer",
    component: _e7204b3c,
    name: "mobile-activity-aigc-ai-cartoonizer"
  }, {
    path: "/mobile/activity/aigc/ai-ideal-mate",
    component: _55a6a3d2,
    name: "mobile-activity-aigc-ai-ideal-mate"
  }, {
    path: "/mobile/activity/aigc/ai-sing",
    component: _2fcd70ae,
    name: "mobile-activity-aigc-ai-sing"
  }, {
    path: "/mobile/clipfly/activity/rule",
    component: _ed057fa0,
    name: "mobile-clipfly-activity-rule"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign",
    component: _1567eff2,
    name: "mobile-goArt-activity-ai-works-campaign"
  }, {
    path: "/mobile/goArt/activity/new-self",
    component: _054f9c08,
    name: "mobile-goArt-activity-new-self"
  }, {
    path: "/mobile/goArt/activity/valentines_day",
    component: _338e4886,
    name: "mobile-goArt-activity-valentines_day"
  }, {
    path: "/mobile/goArt/digital-collection/user-list",
    component: _693cab08,
    name: "mobile-goArt-digital-collection-user-list"
  }, {
    path: "/mobile/goArt/invite-blind-box/Invited-friends",
    component: _08735532,
    name: "mobile-goArt-invite-blind-box-Invited-friends"
  }, {
    path: "/mobile/goArt/invite-blind-box/lucky-draw-record",
    component: _d6c0ea4e,
    name: "mobile-goArt-invite-blind-box-lucky-draw-record"
  }, {
    path: "/mobile/goArt/nft/casting-instructions",
    component: _48a85ba6,
    name: "mobile-goArt-nft-casting-instructions"
  }, {
    path: "/mobile/goArt/nft/helpCenter",
    component: _47874eed,
    name: "mobile-goArt-nft-helpCenter"
  }, {
    path: "/mobile/goArt/nft/how-to-check-nft-on-opensea",
    component: _7e68e49b,
    name: "mobile-goArt-nft-how-to-check-nft-on-opensea"
  }, {
    path: "/mobile/goArt/nft/how-to-view-nft-works-in-opensea",
    component: _5e4241a3,
    name: "mobile-goArt-nft-how-to-view-nft-works-in-opensea"
  }, {
    path: "/mobile/goArt/nft/news",
    component: _d9600ae6,
    name: "mobile-goArt-nft-news"
  }, {
    path: "/mobile/goArt/nft/what-is-encrypted-wallet",
    component: _4f9f4893,
    name: "mobile-goArt-nft-what-is-encrypted-wallet"
  }, {
    path: "/mobile/activity/halloween-2024/views/centerPage",
    component: _1a118584,
    name: "mobile-activity-halloween-2024-views-centerPage"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign/contribute",
    component: _4a463708,
    name: "mobile-goArt-activity-ai-works-campaign-contribute"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign/info",
    component: _1a0cf9ee,
    name: "mobile-goArt-activity-ai-works-campaign-info"
  }, {
    path: "/mobile/goArt/activity/ai-works-campaign/record",
    component: _93cb4728,
    name: "mobile-goArt-activity-ai-works-campaign-record"
  }, {
    path: "/mobile/goArt/activity/new-self/info",
    component: _efba2a30,
    name: "mobile-goArt-activity-new-self-info"
  }, {
    path: "/mobile/goArt/digital-collection/product/all-series",
    component: _b314bd6a,
    name: "mobile-goArt-digital-collection-product-all-series"
  }, {
    path: "/mobile/goArt/nft/article/1",
    component: _25ed109e,
    name: "mobile-goArt-nft-article-1"
  }, {
    path: "/mobile/goArt/nft/article/2",
    component: _25d0e19c,
    name: "mobile-goArt-nft-article-2"
  }, {
    path: "/mobile/goArt/nft/article/3",
    component: _25b4b29a,
    name: "mobile-goArt-nft-article-3"
  }, {
    path: "/mobile/goArt/nft/article/4",
    component: _25988398,
    name: "mobile-goArt-nft-article-4"
  }, {
    path: "/mobile/goArt/nft/article/5",
    component: _257c5496,
    name: "mobile-goArt-nft-article-5"
  }, {
    path: "/mobile/goArt/nft/article/6",
    component: _25602594,
    name: "mobile-goArt-nft-article-6"
  }, {
    path: "/mobile/goArt/nft/protocol/guidelines",
    component: _d814fd1a,
    name: "mobile-goArt-nft-protocol-guidelines"
  }, {
    path: "/mobile/goArt/nft/protocol/guidelines_v2",
    component: _430d1f78,
    name: "mobile-goArt-nft-protocol-guidelines_v2"
  }, {
    path: "/mobile/goArt/nft/protocol/permission",
    component: _13f5afbf,
    name: "mobile-goArt-nft-protocol-permission"
  }, {
    path: "/",
    component: _2ccf1955,
    name: "index"
  }, {
    path: "/mobile/goArt/digital-collection/mine/:id?",
    component: _d27f4ef4,
    name: "mobile-goArt-digital-collection-mine-id"
  }, {
    path: "/mobile/goArt/digital-collection/product/:id?",
    component: _6c89f942,
    name: "mobile-goArt-digital-collection-product-id"
  }, {
    path: "/mobile/goArt/nft/news/:id",
    component: _3fc53c35,
    name: "mobile-goArt-nft-news-id"
  }, {
    path: "/mobile/open-app/:position?",
    component: _d254bf32,
    name: "mobile-open-app-position"
  }, {
    path: "/mobile/clipfly/storys",
    component: _ed3012c6
  }, {
    path: "/mobile/clipfly/song",
    component: _6e0125d4
  }, {
    path: "*",
    component: _23f8d57b,
    name: "custom-404"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
